import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByTags',
  pure: false,
})
export class FilterByTagsPipe implements PipeTransform {

  transform(items: any[], filter: any): any {
    if (!items || !filter) {
      return items;
    }
    let itemsToReturn = [];
    for (var key in filter) {
      if(!filter[key].length){
        itemsToReturn = items;
      }
      items.filter(item => {
        for (let condition of filter[key]) {
          if (item[key].toLowerCase().indexOf(condition.toLowerCase()) !== -1) {
            itemsToReturn.push(item);
            break;
          }
        }
      });
    }
    return itemsToReturn;
  }

}
